export enum ChecktreeItemUpdateMode {
  ONLY_HERE = 'ONLY_HERE',
  CONTAINER = 'CONTAINER',
  ALL = 'ALL',
}
